import React, { useEffect, useState, useCallback } from "react";
import UploadImage from "../Common/upload-image/UploadImage";
import ImageKit from "imagekit-javascript";
import { Formik, Form, Field } from "formik";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import map from "../../images/map-icon.svg";

const GeneralInfo = (props) => {
  const [noImageTextError, setNoImageTextError] = useState("");
  const [imageLoading, setImageLoading] = useState(false);
  const [isNew, setIsNew] = useState(true);

  const imageKit = new ImageKit({
    publicKey: process.env.REACT_APP_PUBLIC_KEY,
    urlEndpoint: process.env.REACT_APP_URL_END_POINT,
    authenticationEndpoint: process.env.REACT_APP_AUTHENTICATION_END_POINT,
  });

  const handleImageUpload = async (imgObj) => {
    setImageLoading(true);

    await imageKit.upload(
      {
        file: imgObj,
        fileName: imgObj.name,
        tags: ["tag1"],
        folder: "/dev/admin",
      },
      (err, result) => {
        if (result) {
          props.setUploadedImg(
            imageKit.url({
              src: result.url,
            })
          );

          setImageLoading(false);
        }
      }
    );
  };

  const onImageDrop = useCallback((acceptedFiles) => {
    handleImageUpload(acceptedFiles[0]);
  }, []);

  const handleChange = (value) => {
    props.setLocation(value);
  };

  const handleSelect = (value) => {
    props.setLocation(value);
    geocodeByAddress(value)
      .then((results) => getLatLng(results[0]))
      .then((latLng) => {
        props.setLocationG({
          type: "Point",
          coordinates: [latLng?.lat, latLng?.lng],
        });
      });
  };

  const [gmapsLoaded, setGmapsLoaded] = useState(false);

  const initMap = () => {
    setGmapsLoaded(true);
  };

  useEffect(() => {
    window.initMap = initMap;
    const gmapScriptEl = document.createElement(`script`);
    gmapScriptEl.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_API_URL}&callback=initMap&libraries=places&callback=initMap`;
    document
      .querySelector(`body`)
      .insertAdjacentElement(`beforeend`, gmapScriptEl);
  }, []);

  return (
    <div className="attraction-row">
      <div className="title">
        <h2>Attraction information</h2>
        <p>Please enter in your attraction’s information.</p>
      </div>
      <Formik
        initialValues={{
          name: `${props?.data?.name ? props?.data?.name : ""}`,
          description: `${
            props?.data?.description ? props?.data?.description : ""
          }`,
          categories: `${
            props?.data?.categories ? props?.data?.categories : ""
          }`,
        }}
        onSubmit={() => {
          if (
            props.uploadedImg &&
            props.location &&
            props.categories &&
            props.description &&
            props.attractionName
          ) {
            props.next({
              categories: props.categories,
              description: props.description,
              name: props.attractionName,
              image_url: props.uploadedImg,
              location_text: props.location,
              location: props.locationG,
            });
          }
        }}
      >
        {() => (
          <Form>
            <div className="attraction-info">
              <div className="col-left">
                <div className="login-form">
                  <div className="form-group">
                    <label>Attraction Name</label>
                    <Field
                      type="text"
                      name="name"
                      className="form-control"
                      onChange={(e) => {
                        props.setAttractionName(e.target.value);
                      }}
                      value={props.attractionName}
                    />
                    {!props.attractionName && !isNew ? (
                      <p className="error-message">Attraction Name required</p>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="form-group">
                    <label>Description</label>
                    <Field
                      name="description"
                      as="textarea"
                      placeholder="Description"
                      className="form-control"
                      onChange={(e) => {
                        props.setDescription(e.target.value);
                      }}
                      value={props.description}
                    />

                    {!props.description && !isNew ? (
                      <p className="error-message">
                        Attraction Description required
                      </p>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="form-group">
                    <label>Attraction Category</label>

                    <Field
                      name="categories"
                      as="select"
                      className="form-control"
                      onChange={(e) => {
                        props.setCategories(e.target.value);
                      }}
                      value={props.categories}
                    >
                      <option value="">Select Category</option>
                      {props?.categoriesData?.type_of_attractions?.map(
                        (category) => {
                          return (
                            <option value={category?.name}>
                              {category?.name}
                            </option>
                          );
                        }
                      )}
                    </Field>

                    {!props.categories && !isNew ? (
                      <p className="error-message">
                        Attraction Categories required
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group map-input">
                    <label>Location</label>

                    {gmapsLoaded && (
                      <PlacesAutocomplete
                        onSelect={handleSelect}
                        value={props.location}
                        onChange={handleChange}
                      >
                        {({
                          loading,
                          suggestions,
                          getInputProps,
                          getSuggestionItemProps,
                        }) => (
                          <div>
                            <img
                              src={map}
                              alt="map-icon"
                              style={{
                                marginRight: "10px",
                                marginTop: "13px",
                                position: "absolute",
                                marginLeft: "10px",
                              }}
                            />

                            <input
                              {...getInputProps({
                                placeholder: "Enter Location...",
                              })}
                              className="lg-form-control"
                              style={{ width: "100%", paddingLeft: "30px" }}
                              type="text"
                            />

                            <div
                              style={{
                                border:
                                  suggestions && suggestions.length > 0
                                    ? "1px solid #e8e9eb"
                                    : "",
                              }}
                              className="suggestion-box"
                            >
                              {loading && <div>Loading...</div>}
                              {suggestions
                                // .filter(
                                //   (item) =>
                                //     item.terms[item.terms.length - 1].value ===
                                //     "Australia"
                                // )

                                .map((suggestion, index) => {
                                  const style = suggestion.active
                                    ? {
                                        backgroundColor: "rgb(19 173 250)",
                                        cursor: "pointer",
                                      }
                                    : {
                                        backgroundColor: "#ffffff",
                                        cursor: "pointer",
                                      };

                                  return (
                                    <div
                                      {...getSuggestionItemProps(suggestion, {
                                        style,
                                      })}
                                      key={index}
                                    >
                                      {suggestion.description}
                                    </div>
                                  );
                                })}
                            </div>
                            {!props.location && !isNew ? (
                              <p className="error-message">
                                Attraction Location required
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                        )}
                      </PlacesAutocomplete>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-right">
                <div
                  className="form-group add-image-group"
                  style={{ marginBottom: "0px" }}
                >
                  <label>Add images</label>
                  <div className="image-group">
                    <UploadImage
                      titleNeeded={false}
                      onImageDrop={onImageDrop}
                      disabled={!!props.uploadedImg}
                      uploadedImg={props.uploadedImg}
                      setUploadedImg={props.setUploadedImg}
                      loading={imageLoading}
                    />
                  </div>
                </div>
                {noImageTextError && !props.uploadedImg ? (
                  <div className="error-message">{noImageTextError}</div>
                ) : null}
              </div>
            </div>

            <div className="form-submit event-button-row submit">
              <button
                type="submit"
                className="submit-btn next-btn"
                onClick={() => {
                  if (!props.uploadedImg) {
                    setNoImageTextError("Please upload a image");
                  }
                  setIsNew(false);
                }}
              >
                Next
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default GeneralInfo;
